import { z } from 'zod';

export const changeOrderLineItemInputSchema = z.object({
  partNumber: z.string().min(1).max(100),
  quantity: z.number().int().positive(),
});

export type ChangeOrderLineItemInput = z.infer<typeof changeOrderLineItemInputSchema>;

export const changeOrderCreateSchema = z.object({
  cwProjectId: z.number().int().positive(),
  title: z.string().min(1).max(200),
  requiredChanges: z.string().min(1).max(5000),
  estimatedHours: z.number().positive(),
  lineItems: z.array(changeOrderLineItemInputSchema).optional().default([]),
  needsEngineering: z.boolean().optional().default(false),
});

/** Compact one-line summary of parts, e.g. "P123 ×2; P456 ×1" (or "None"). */
export function formatChangeOrderParts(lineItems: ChangeOrderLineItemInput[]): string {
  if (!lineItems.length) return 'None';
  return lineItems.map((li) => `${li.partNumber} ×${li.quantity}`).join('; ');
}
